import { EventParticipant } from "./MyRegistrationComponent";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Info } from "lucide-react";
import { Button } from "../ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
//@ts-ignore
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface CusotmPopoverComponentProps {
  evntParticipants: EventParticipant[];
}
export function CusotmPopoverComponent({
  evntParticipants,
}: CusotmPopoverComponentProps) {
  return (
    <div className="w-full">
      <Popover>
        <PopoverTrigger>
          <Button variant="outline" size="sm" className="text-[#595959]">
            View <Info className="ml-2 h-4 w-4" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="max-w-sm w-full md:max-w-lg ">
          <Table className="border text-sm overflow-x-scroll rounded-lg  drop-shadow-lg z-50">
            <TableHeader>
              <TableRow className="w-full  ">
                <TableHead className="bg-gray-400  text-white">
                  Participants Name
                </TableHead>
                <TableHead className="bg-gray-400  text-white">
                  Category
                </TableHead>
                <TableHead className="bg-gray-400  text-white">Price</TableHead>
                <TableHead className="bg-gray-400  text-white">
                  Aadhar Verification Status
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {evntParticipants?.map((user) => {
                return (
                  <TableRow key={user?.id}>
                    <TableCell>{user?.member?.name}</TableCell>
                    <TableCell>{user?.category?.name}</TableCell>
                    <TableCell className="">
                      <div className="flex gap-3">
                        {user?.category?.price / 100}
                      </div>
                    </TableCell>
                    <TableCell className="text-center">
                      <Badge
                        className={cn(
                          user?.member?.user?.status === "REJECTED"
                            ? "bg-red-400 text-white"
                            : user?.member?.user?.status === "UNVERIFIED"
                            ? "bg-yellow-400 text-white"
                            : user?.member?.user?.status === "VERIFIED"
                            ? "bg-green-400 text-white"
                            : "bg-gray-200 text-black" // Default color for other statuses
                        )}
                      >
                        {user?.member?.user?.status}
                      </Badge>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </PopoverContent>
      </Popover>
    </div>
  );
}
